import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import getToken from '../helpers/getToken';
import axios from 'axios';
import useSWR from 'swr';
import { Modal } from 'react-bootstrap';
import { ToastContainer } from 'react-toastify';
import { successAlert, errorAlert } from '../utils/toastifyAlerts';
import DeleteResume from '../helpers/deleteResume';
import downloadResumeAsJson from '../helpers/downloadResumeAsJson';

const UserResumes = () => {
    const navigate = useNavigate();

    const [showShareModal, setShowShareModal] = useState(false);
    const [selectedResumeId, setSelectedResumeId] = useState(null);

    const handleCloseShareModal = () => setShowShareModal(false);

    let backendUrl = process.env.REACT_APP_BACKEND_RESUME_URL;
    const token = getToken();
    const fetcher = url => axios.get(url, {
        headers: {
            token: token,
        },
    }).then(response => {
        return (response.data);
    })

    const { data, error, isLoading, mutate } = useSWR(backendUrl, fetcher)
    if (error) return <div className='MyCVUser'><h5>failed to load your resumes, try login again please</h5></div>
    if (isLoading) return <div className='MyCVUser'>loading...</div>

    const handleViewResume = (id) => {
        navigate('/resumeViewer', {
            state: {
                resumeId: id,
            }
        });
        // console.log(`Abriendo vista de CV con ID: ${id}`);
        // alert('Funcionalidad Resume Viewer pendiente de implementación.');
    }

    const handleResumeEditor = (id) => {
        navigate('/resumeEditor', {
            state: {
                resumeId: id,
            }
        });
    }

    const handleDeleteResume = async (id) => {
        // Use a confirmation dialog before deleting
        if (window.confirm('Are you sure you want to delete this resume?')) {
            try {
                const response = await DeleteResume(id, token);
                successAlert(response.data.msg || 'Resume deleted successfully!');
                mutate().catch(err => {
                    console.error("Failed to re-fetch resumes after deletion:", err);
                    errorAlert("Could not refresh the resume list. Please reload the page.");
                });
            } catch (err) {
                console.error('Error deleting resume:', err);
                errorAlert(err.response?.data?.msg || 'Failed to delete resume.');
            }
        }
    };

    const handleShareClick = (id) => {
        setSelectedResumeId(id);
        setShowShareModal(true);
    };

    // const handleDownload = () => {
    //     // Lógica para descargar el CV (ej. como PDF o JSON)
    //     console.log(`Descargando CV con ID: ${selectedResumeId}`);
    //     alert('Funcionalidad de descarga pendiente de implementación.');
    //     handleCloseShareModal();
    // };

    const handleDownloadClick = () => {
        // A more descriptive name could be resume.title or similar
        downloadResumeAsJson(selectedResumeId);
    };

    const handleCopyLink = () => {
        const shareLink = `${window.location.origin}/resumeViewer/${selectedResumeId}`;
        navigator.clipboard.writeText(shareLink).then(() => {
            successAlert('Link copied to clipboard!');
        }).catch(err => {
            console.error('Error al copiar el vínculo: ', err);
            errorAlert('Sorry, could not copy the link to clipboard. Please try again');
        });
        handleCloseShareModal();
    };

    const handleSendVia = async () => {
        const shareData = {
            title: 'My Resume',
            text: 'Check out my resume.',
            url: `${window.location.origin}/resumeViewer/${selectedResumeId}`
        };
        if (navigator.share && navigator.canShare(shareData)) {
            await navigator.share(shareData).catch(err => console.error('Error sharing:', err));
        } else {
            // Fallback para navegadores sin Web Share API
            alert('Your browser does not support this feature. Please copy the link manually.');
        }
        handleCloseShareModal();
    };

    return (
        <div>
            <h2 className="mx-3 mt-3 resumeTitle">your resumes</h2>
            {data && data.map((resume, index) => (
                <div className="MyCV" key={index}>
                    <div className="CV">
                        <h6 data-test="position" resumeid={resume._id} onClick={() => handleViewResume(resume._id)} >{resume.position}</h6>
                        <h6 data-test="creation date">{resume.creationDate.split('T')[0]}</h6>
                    </div>
                    <div className="ESD">
                        <button className="btnSCV-ESD" data-test="edit" resumeid={resume._id} onClick={() => handleResumeEditor(resume._id)}>Edit</button>
                        <button className="btnSCV-ESD" data-test="share" resumeid={resume._id} onClick={() => handleShareClick(resume._id)}>Share</button>
                        <button className="btnSCV-ESD" data-test="delete" resumeid={resume._id} onClick={() => handleDeleteResume(resume._id)}>Delete</button>
                    </div>
                </div>
            ))}

            <Modal show={showShareModal} onHide={handleCloseShareModal} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Share Resume</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                        <button className="btnSCV btnSCV-a" onClick={handleDownloadClick}>
                            Download json file
                        </button>
                        <button className="btnSCV btnSCV-a" onClick={handleCopyLink}>
                            Copy Link
                        </button>
                        <button className="btnSCV btnSCV-a" onClick={handleSendVia}>
                            Send via...
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
            <ToastContainer />
        </div>
    )
}

export default UserResumes